import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Select, TextField } from '@mui/material';

import '../compras.css';
import './form.css';
import './tabla.css';

import { FormActions } from './FormActions';
import { TablaCompras } from './TablaCompras';

import { Totales } from './Totales';
import { DatosIniciales } from './DatosIniciales';

import { PaymentsModal } from '../../payments/PaymentsModal';
import { PaymentsModalList } from '../../payments/PaymentsModalList';
import { InvoceModalList } from '../../invoice/InvoceModalList';

import { useBuy } from '../../../hooks/useBuy';
import { usePay } from '../../../hooks/usePay';

import { getFinalTotals, getInfoTipoDoc, setNewItemsValues, calcDetraccion } from '../../../helpers/compras';
import { JustificadoModal } from '../justificado/JustificadoModal';
import { MontosAPagar } from './MontosAPagar';
import { toast } from 'react-toastify';
import { useCallback } from 'react';

export const ComprasForm = ({ initialState = {}, loadIniBudget, setOpenExtendedMode }) => {
    /* console.log({initialState})
 */
    let { compraId } = useParams()

    const { listaTiposDocumentos, currencyList } = useSelector(state => state.general)

    const { detailBuy, initGetOneBuy } = useBuy()
    const { detailPay, initCreateNewPay } = usePay()

    const [form, setForm] = useState(compraId ? detailBuy : initialState)
    const [paymentsModal, setPaymentsModal] = useState(false)
    const [justificadoModal, setJustificadoModal] = useState(false)
    const [paymentsModalList, setPaymentsModalList] = useState(false)
    const [invoceModalList, setInvoceModalList] = useState(false)
    const [itemsSelected, setItemsSelected] = useState([])
    // console.log({ itemsSelected })

    const checkInitialData = useCallback(async (compraId) => {
        await initGetOneBuy(compraId)
    }, [initGetOneBuy])

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleChangePorcentajeDetraccion = async ({ target }) => {
        const newPorcentaje = parseFloat(target.value)

        const resultCalc = await calcDetraccion({
            ...form,
            porcentaje_detraccion: newPorcentaje
        })

        setForm({
            ...form,
            porcentaje_detraccion: newPorcentaje,
            ...resultCalc
        })
    }

    const handleChangeMoneda = ({ target }) => {
        const newIdMoneda = parseInt(target.value)
        const selectedMoney = currencyList?.find(it => it.id === newIdMoneda)
        setForm({
            ...form,
            [target.name]: newIdMoneda,
            separacion_decimales: selectedMoney?.separacion_decimales,
            separacion_miles: selectedMoney?.separacion_miles,
            simbolo: selectedMoney?.simbolo
        });
    }

    const handleChangeItemsTotals = async (values, target, itemId) => {

        const changedData = {
            itemId,
            target,
            floatValue: values.floatValue,
            items: form.items
        }

        const newItems = await setNewItemsValues(changedData)
        const { sub_total, monto_base, total_impuesto, total_compra, total_pagado, total_por_pagar } = await getFinalTotals(form, newItems)

        const resultCalc = await calcDetraccion({
            ...form,
            total_compra
        })

        setForm({
            ...form,
            subtotal: sub_total,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_compra: total_compra,
            total_pagado: total_pagado,
            total_por_pagar: total_por_pagar,
            items: newItems,
            ...resultCalc
        })

    }

    const handleChangeItemsName = async (newName, itemId) => {

        /* console.log(newName, itemId) */

        const newItems = form.items.map(it => {

            /* if (parseInt(it.id) === parseInt(itemId)) {
                return {
                    ...it,
                    nombre: newName
                }
            } */

            if (it.id === itemId) {
                return {
                    ...it,
                    nombre: newName
                }
            }

            return it

        })

        setForm({
            ...form,
            items: newItems
        })

    }

    const handleChangeCheck = async ({ target }) => {

        setForm({
            ...form,
            [target.name]: target.checked
        });

        if (target.checked && target.name === 'pagado') {

            // valida para seguir pagando o no de una sola forma = por items o general
            if (form.pay_for_items && itemsSelected.length === 0) {
                toast.warning('Falta seleccionar ítems para pagar')
                return false
            }

            await initCreateNewPay(form, itemsSelected)
            setItemsSelected([])
            setPaymentsModal(true)

        }

        if (target.checked && target.name === 'justificado') {
            await initCreateNewPay(form)
            setJustificadoModal(true)
        }

    }

    const handleChangeCheckDetraccion = async (e) => {
        const { checked } = e.target

        const newForm = {
            ...form,
            aplica_detraccion: checked
        }

        const resultCalc = await calcDetraccion(newForm)

        setForm({
            ...newForm,
            ...resultCalc
        })

    }

    const handleChangeTipoDoc = async ({ target }) => {
        const newTipoDocId = target.value

        const { impuesto_nombre, impuesto_porcentaje, impuesto_tipo_calculo } = await getInfoTipoDoc(listaTiposDocumentos, newTipoDocId)

        let newDataForm = {
            ...form,
            id_tipo_documento: newTipoDocId,
            impuesto_nombre: impuesto_nombre,
            impuesto_porcentaje: impuesto_porcentaje,
            impuesto_tipo_calculo: impuesto_tipo_calculo
        }

        const { sub_total, monto_base, total_impuesto, total_compra, total_pagado, total_por_pagar } = await getFinalTotals(newDataForm, newDataForm.items)

        const resultCalc = await calcDetraccion({
            ...newDataForm,
            total_compra
        })

        setForm({
            ...newDataForm,
            subtotal: sub_total,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_compra: total_compra,
            total_pagado: total_pagado,
            total_por_pagar: total_por_pagar,
            ...resultCalc
        })

    }

    const handleChangeProveedor = (proveedor) => {
        setForm({
            ...form,
            'id_proveedor': proveedor.id_proveedor,
        });
    }

    const handleChangeTipoCambio = (value) => {
        setForm({
            ...form,
            'valor_tipo_cambio': value.floatValue,
        });
    }

    const handleChangeDate = (date, name) => {
        console.log(date, name)
        setForm({
            ...form,
            [name]: date,
        });
    }

    const handleItemSelected = (e, item, from) => {
        const { checked } = e.target

        const newId = (from === 'item' ? item?.id : from)
        const newMonto = (from === 'item' ? item?.subtotal : item.monto)
        const newFlowId = (from === 'item' ? item?.flow_id : null)
        const referencia = (from === 'item' ? item?.nombre : from)

        const newItem = {
            id: newId,
            referencia,
            monto_a_pagar: newMonto,
            flow_id: newFlowId,
            from
        }

        if (checked) {

            setItemsSelected([
                ...itemsSelected,
                newItem
            ])

        } else {

            const listUpdated = itemsSelected.filter(it => it.id !== newItem.id)
            setItemsSelected(listUpdated)

        }

    }

    useEffect(() => {
        if (compraId) {
            checkInitialData(compraId)
        }

        return () => {
            if (!compraId) {
                loadIniBudget()
            }
        }

    }, [compraId, checkInitialData, loadIniBudget])

    useEffect(() => {
        if (compraId) {
            setForm(detailBuy)
        }
    }, [compraId, detailBuy])

    return (
        <div className='p-compras-box'>

            {paymentsModal &&
                <PaymentsModal
                    initialPay={detailPay}
                    title={detailBuy?.pays?.length > 0 ? 'Pago emitido' : 'Pagar gasto'}
                    openModal={paymentsModal}
                    setModal={setPaymentsModal}
                    dataCompra={form}
                    checkInitialData={checkInitialData}
                />
            }

            {paymentsModalList &&
                <PaymentsModalList
                    compraId={form.id}
                    title='Pagos realizados'
                    openModal={paymentsModalList}
                    dataCompra={form}
                    setModal={setPaymentsModalList}
                    checkInitialData={checkInitialData}
                />
            }

            {invoceModalList &&
                <InvoceModalList
                    title='Factura justificada'
                    openModal={invoceModalList}
                    setModal={setInvoceModalList}
                    dataCompra={form}
                    setForm={setForm}
                    checkInitialData={checkInitialData}
                />
            }

            {justificadoModal &&
                <JustificadoModal
                    title={detailBuy?.nro_doc_justificacion ? 'Justificado' : 'Justificar'}
                    openModal={justificadoModal}
                    setModal={setJustificadoModal}
                    dataCompra={form}
                    checkInitialData={checkInitialData}
                />
            }

            {form.id > 0 &&
                <div className="row">
                    <div className="col-10">
                        <Link to={-1} className='d-inline-flex align-items-center mb-2 p-arrow-back'>
                            <i className="bi bi-arrow-left"></i>
                            <span className='ms-2'>Gasto #{form.numero}</span>
                        </Link>

                        <select
                            name="tipo_gasto"
                            value={form.tipo_gasto || 'oc'}
                            className='ms-3'
                            style={{ border: 'none', color: 'gray' }}
                            onChange={handleChange}
                        >
                            <option value="oc">Orden de compra</option>
                            <option value="os">Orden de servicio</option>
                        </select>

                    </div>
                    <div className='col-2 d-inline-flex justify-content-end align-items-center'>
                        {form.estado === 'emitida' &&
                            <span className='p-pptos-estado p-emitida' style={{ marginRight: '0px' }}>Emitida</span>
                        }
                        {form.estado === 'pagada' &&
                            <span className='p-pptos-estado p-pagada' style={{ marginRight: '0px' }}>Pagada</span>
                        }
                        {form.estado === 'anulada' &&
                            <span className='p-pptos-estado p-anulada' style={{ marginRight: '0px' }}>Anulada</span>
                        }
                    </div>
                </div>
            }

            <div className='d-flex'>
                {form.origen === 'ventas' ?
                    <Link className='p-link-origen' to={`/projects/${form.id_ppto}`} target={"_blank"}>
                        Proyecto: {form.referencia_origen}
                    </Link>
                    :
                    <Link className='p-link-origen' to={`/gastos/pptos/${form.id_ppto}`} target={"_blank"}>
                        Ppto interno: {form.referencia_origen}
                    </Link>
                }
            </div>

            <div className='mt-3'>
                <FormActions
                    checkInitialData={checkInitialData}
                    setForm={setForm}
                    dataForm={form}
                    setPaymentsModal={setPaymentsModal}
                    setPaymentsModalList={setPaymentsModalList}
                    setInvoceModalList={setInvoceModalList}
                    setOpenExtendedMode={setOpenExtendedMode}
                    loadIniBudget={loadIniBudget}
                />
            </div>

            <div className='mt-4 p-box-datos'>
                <DatosIniciales
                    dataForm={form}
                    handleChange={handleChange}
                    handleChangeProveedor={handleChangeProveedor}
                    handleChangeDate={handleChangeDate}
                    handleChangeTipoDoc={handleChangeTipoDoc}
                    handleChangeCheck={handleChangeCheck}
                    handleChangeTipoCambio={handleChangeTipoCambio}
                    handleChangeMoneda={handleChangeMoneda}
                />
            </div>

            <div className='row mt-3 p-box-datos'>
                <div className='col p-pptos-form-tabla'>

                    {(
                        ((parseFloat(form.total_compra) * (parseInt(form.id_moneda) === 4 ? parseFloat(form?.valor_tipo_cambio) : 1)) >= 700)
                        && parseInt(form.id_tipo_documento) === 1
                    ) &&
                        <div className='d-flex justify-content-end align-items-center'>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={handleChangeCheckDetraccion}
                                        checked={form.aplica_detraccion}
                                        style={{ color: '#8E24AA' }}
                                        disabled={form.reading_mode}
                                    />
                                }
                                label="Aplica detracción"
                            />

                            <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                                <Select
                                    style={{ textAlign: 'center' }}
                                    name="porcentaje_detraccion"
                                    value={form.porcentaje_detraccion || 12}
                                    onChange={handleChangePorcentajeDetraccion}
                                    disabled={form.reading_mode}
                                >
                                    <MenuItem value={10}>10%</MenuItem>
                                    <MenuItem value={12}>12%</MenuItem>
                                    <MenuItem value={4}>4%</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    }

                    <div className="table-responsive">
                        <TablaCompras
                            dataForm={form}
                            handleChangeItemsTotals={handleChangeItemsTotals}
                            handleChangeItemsName={handleChangeItemsName}
                            handleItemSelected={handleItemSelected}
                        />
                    </div>
                </div>
            </div>

            <Grid container className='mt-2'>
                <Grid item xs={12} md={6}>
                    <TextField
                        className='p-compras-box-observaciones'
                        id="standard-multiline-static"
                        label="Observaciones"
                        placeholder="Ingrese alguna observación para el gasto"
                        multiline
                        rows={4}
                        name="observaciones"
                        value={form.observaciones || ''}
                        onChange={handleChange}
                        disabled={form.reading_mode}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <Totales
                        dataForm={form}
                    />
                    <MontosAPagar
                        dataForm={form}
                        handleItemSelected={handleItemSelected}
                    />
                </Grid>
            </Grid>




        </div>
    )
}